import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider as TemplatesContextProvider } from 'components/Managers/Templates/Context';
import Main from './Main';

export default function Index({ enterpriseId }) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <TemplatesContextProvider enterpriseId={enterpriseId}>
          <Main enterpriseId={enterpriseId} />
        </TemplatesContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
